import type { ThemeConfig } from "../../types";

export const modernTheme: ThemeConfig = {
  weak: { color: "#f43f5e", label: "Not Secure" },
  fair: { color: "#fb923c", label: "Could Be Better" },
  good: { color: "#38bdf8", label: "Secure" },
  strong: { color: "#34d399", label: "Very Secure" },
};
